/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsLokaliseModule,
    ControlcenterMelcoControlCenterModelsLokaliseModuleFromJSON,
    ControlcenterMelcoControlCenterModelsLokaliseModuleFromJSONTyped,
    ControlcenterMelcoControlCenterModelsLokaliseModuleToJSON,
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule
 */
export interface ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule {
    /**
     * 
     * @type {Array<ControlcenterMelcoControlCenterModelsLokaliseModule>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule
     */
    list: Array<ControlcenterMelcoControlCenterModelsLokaliseModule>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule {
    return ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseModuleFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModuleToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsLokaliseModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoControlCenterModelsLokaliseModuleToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


